import React from 'react';
import ReactDOM from 'react-dom/client';
import  { GlobalStyle } from './styles/global/Global.styled';
import AdEPorto from './AdEPorto';
import StyledSelect from './styles/global/Select.styled';
import StyledButton from './styles/global/Button.styled';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <GlobalStyle />
    <StyledButton/>
    <StyledSelect />
    <AdEPorto />
  </>
);
